import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, CircularProgress } from '@mui/material';
import CommonButton from '@src/new-components/Button';
import CustomTypography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import policyIcon from '@src/assets/images/bgm-policy-icon.png';
import sanitize from 'sanitize-html';
import { StyledAction, StyledConsent, StyledPolicyDialog } from './index.style';

const BGMTermsPolicyDialog = ({ open, loading, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (!open) setIsChecked(false);
  }, [open]);

  const handleConfirm = () => {
    if (!isChecked || loading) return;
    onConfirm();
  };

  return (
    <StyledPolicyDialog
      open={open}
      fullWidth
      width="512px"
      widthContent="100%"
      paddingMobile="16px"
      marginMobile="16px"
      image={policyIcon}
      imageSize="64px"
      title={t('policyAgreementTitle')}
      styleTitle={{ letterSpacing: '-0.4px' }}
      onClose={onClose}
      contentComponent={
        <StyledConsent>
          <Checkbox
            className="policy-consent-checkbox"
            checked={isChecked}
            onChange={() => setIsChecked((value) => !value)}
            data-id="policy-agreement-checkbox"
          />
          <CustomTypography
            className="policy-consent-label"
            variant="body-14-regular"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitize(t('backgroundMusicCopyrightConsent'), {
                allowedTags: ['b', 'a'],
              }),
            }}
          />
        </StyledConsent>
      }
      actionComponent={
        <StyledAction>
          <CommonButton
            variant="contained"
            disabled={!isChecked || loading}
            onClick={handleConfirm}
            data-id="confirm-policy-agreement"
            className="policy-confirm-button"
            bgrDisabled={COLOR.yellow.default}
            startIcon={
              loading ? (
                <CircularProgress size={16} sx={{ color: COLOR.darkBlue }} />
              ) : null
            }
            textProps={{
              variantText: 'body-14-semibold',
              color: COLOR.darkBlue,
            }}
            customStyle={{
              height: '40px',
              padding: '8px 24px',
              borderRadius: '8px',
              '&:disabled': {
                opacity: 0.32,
                backgroundColor: COLOR.yellow.default,
                cursor: 'not-allowed',
                pointerEvents: 'auto',
              },
            }}
          >
            {t('confirm')}
          </CommonButton>
        </StyledAction>
      }
    />
  );
};

export default BGMTermsPolicyDialog;
